import { Input } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React, { useRef } from "react";

export default function ReadOnlyCopyInput({
  onCopy,
  value,
}: {
  onCopy?: (value: string) => void;
  value: string;
}) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleCopy = React.useCallback(
    (value: $TSFixMe) => {
      // @ts-ignore TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onCopy(value);
    },
    [onCopy],
  );

  const selectAll = React.useCallback(() => {
    const input = inputRef.current;
    // @ts-ignore TS(2531): Object is possibly 'null'.
    input.setSelectionRange(0, input.value.length);
  }, [inputRef]);

  return (
    <Input
      ref={inputRef}
      style={{ width: "100%" }}
      type="text"
      readOnly
      value={value}
      onCopy={handleCopy}
      onFocus={selectAll}
      onBlur={selectAll}
      onSelect={selectAll}
    />
  );
}
